"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _underscore = _interopRequireDefault(require("FileManagerCore/vendor/underscore.custom"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Constants = require("FileManagerCore/Constants");

var _propTypes2 = require("FileManagerCore/constants/propTypes");

var _Constants2 = require("../../Constants");

var Actions = _interopRequireWildcard(require("../../actions/Actions"));

var _FoldersAndFilesContainer = _interopRequireDefault(require("../../containers/browser/FoldersAndFilesContainer"));

var _EmptySearchResults = _interopRequireDefault(require("./EmptySearchResults"));

var _Tiles = require("../../selectors/Tiles");

var _Shutterstock = require("../../actions/Shutterstock");

var _Shutterstock2 = _interopRequireDefault(require("./Shutterstock"));

var _ShutterstockTOS = _interopRequireDefault(require("./ShutterstockTOS"));

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _Configuration = require("../../selectors/Configuration");

var _Files = require("FileManagerCore/selectors/Files");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _FolderFetch = require("FileManagerCore/actions/FolderFetch");

var _StockImagesNoAccess = _interopRequireDefault(require("FileManagerCore/components/permissions/StockImagesNoAccess"));

var _Tiles2 = require("../../utils/Tiles");

var _network = require("../../utils/network");

var SearchPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchPanel, _Component);

  function SearchPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SearchPanel).call(this, props));
    _this.handleSearch = _this.handleSearch.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadMoreRows = _this.handleLoadMoreRows.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadMoreStockImages = _this.handleLoadMoreStockImages.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetch = _this.fetch.bind((0, _assertThisInitialized2.default)(_this));
    _this.debouncedFetch = _underscore.default.debounce(_this.fetch, 500);
    return _this;
  }

  (0, _createClass2.default)(SearchPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          searchQuery = _this$props.searchQuery,
          onTrackInteraction = _this$props.onTrackInteraction,
          type = _this$props.type,
          withPanelNavigator = _this$props.withPanelNavigator;
      onTrackInteraction('Browse Shutterstock', 'started-search');

      if (!withPanelNavigator) {
        this.fetch({
          initial: true,
          searchQuery: searchQuery,
          page: 1,
          pageSize: _Constants2.PAGE_SIZE,
          type: type
        });
      } else {
        this.props.searchFolders(searchQuery);
      }
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          fetchFiles = _this$props2.fetchFiles,
          fetchStockFiles = _this$props2.fetchStockFiles,
          type = _this$props2.type,
          isShutterstockEnabled = _this$props2.isShutterstockEnabled,
          readOnlyReason = _this$props2.readOnlyReason;
      fetchFiles(Object.assign({}, options, {
        type: type
      }));

      if (isShutterstockEnabled && type === _Constants2.DrawerTypes.IMAGE && !readOnlyReason) {
        fetchStockFiles(Object.assign({}, options, {
          type: type
        }));
      }

      this.props.searchFolders(options.searchQuery);
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(event) {
      var _this$props3 = this.props,
          onSearch = _this$props3.onSearch,
          type = _this$props3.type,
          withPanelNavigator = _this$props3.withPanelNavigator;
      var searchQuery = event.target.value;

      if (!withPanelNavigator) {
        this.debouncedFetch({
          initial: true,
          searchQuery: searchQuery,
          page: 1,
          pageSize: _Constants2.PAGE_SIZE,
          type: type
        });
      }

      onSearch(searchQuery);
    }
  }, {
    key: "handleLoadMoreRows",
    value: function handleLoadMoreRows() {
      var _this$props4 = this.props,
          status = _this$props4.status,
          files = _this$props4.files,
          fetchFiles = _this$props4.fetchFiles,
          searchQuery = _this$props4.searchQuery,
          type = _this$props4.type;

      if (status === _Constants.RequestStatus.PENDING) {
        return;
      }

      fetchFiles({
        offset: files.count(),
        type: type,
        searchQuery: searchQuery
      });
    }
  }, {
    key: "handleLoadMoreStockImages",
    value: function handleLoadMoreStockImages() {
      var _this$props5 = this.props,
          stockImages = _this$props5.stockImages,
          fetchStockFiles = _this$props5.fetchStockFiles,
          searchQuery = _this$props5.searchQuery,
          type = _this$props5.type,
          stockStatus = _this$props5.stockStatus;

      if (stockStatus === _Constants.RequestStatus.PENDING) {
        return;
      }

      var page = Math.ceil(stockImages.size / _Constants2.PAGE_SIZE) + 1;
      fetchStockFiles({
        searchQuery: searchQuery,
        page: page,
        pageSize: _Constants2.PAGE_SIZE,
        type: type
      });
    }
  }, {
    key: "renderTiles",
    value: function renderTiles() {
      var _this$props6 = this.props,
          type = _this$props6.type,
          total = _this$props6.total,
          tiles = _this$props6.tiles,
          status = _this$props6.status,
          disableUpload = _this$props6.disableUpload,
          onInsert = _this$props6.onInsert,
          previousSelectedFileId = _this$props6.previousSelectedFileId,
          withPanelNavigator = _this$props6.withPanelNavigator;

      if (status === _Constants.RequestStatus.SUCCEEDED && total === 0) {
        return _react.default.createElement(_EmptySearchResults.default, null);
      }

      return _react.default.createElement(_FoldersAndFilesContainer.default, {
        type: type,
        tiles: tiles,
        total: total,
        onInsert: onInsert,
        onLoadMoreFiles: this.handleLoadMoreRows,
        disableUpload: disableUpload,
        withPanelNavigator: withPanelNavigator,
        previousSelectedFileId: previousSelectedFileId
      });
    }
  }, {
    key: "renderShutterstockTiles",
    value: function renderShutterstockTiles() {
      var _this$props7 = this.props,
          stockStatus = _this$props7.stockStatus,
          stockTiles = _this$props7.stockTiles,
          stockTotal = _this$props7.stockTotal,
          onInsert = _this$props7.onInsert,
          withPanelNavigator = _this$props7.withPanelNavigator;

      if (stockStatus === _Constants.RequestStatus.SUCCEEDED && stockTotal === 0) {
        return _react.default.createElement(_EmptySearchResults.default, null);
      }

      return _react.default.createElement(_Shutterstock2.default, {
        tiles: stockTiles,
        total: stockTotal,
        onInsert: onInsert,
        onLoadMoreImages: this.handleLoadMoreStockImages,
        withPanelNavigator: withPanelNavigator
      });
    }
  }, {
    key: "renderShutterstockTabContent",
    value: function renderShutterstockTabContent() {
      if (this.props.readOnlyReason) {
        return _react.default.createElement(_StockImagesNoAccess.default, {
          readOnlyReason: this.props.readOnlyReason,
          showIllustration: false
        });
      }

      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_ShutterstockTOS.default, {
        use: "light"
      }), this.renderShutterstockTiles());
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      return _react.default.createElement(_UITabs.default, {
        defaultSelected: "files",
        className: "search-panel__tab-growth-fix",
        panelClassName: "search-panel__tab-growth-fix p-x-0 flex"
      }, _react.default.createElement(_UITab.default, {
        tabId: "files",
        title: _I18n.default.text('FileManagerLib.panels.tabs.files')
      }, this.renderTiles()), _react.default.createElement(_UITab.default, {
        tabId: "shutterstock",
        title: _I18n.default.text('FileManagerLib.panels.tabs.shutterstock.heading')
      }, this.renderShutterstockTabContent()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          searchQuery = _this$props8.searchQuery,
          onBack = _this$props8.onBack,
          isShutterstockEnabled = _this$props8.isShutterstockEnabled,
          type = _this$props8.type,
          withPanelNavigator = _this$props8.withPanelNavigator;
      return _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, _react.default.createElement(_UISearchInput.default, {
        className: "m-top-3",
        value: searchQuery,
        onChange: this.handleSearch,
        "data-test-id": "drawer-search-input"
      }), !withPanelNavigator && _react.default.createElement(_UIBackButton.default, {
        className: "search-panel__back-button m-top-6"
      }, _react.default.createElement(_UILink.default, {
        onClick: onBack
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.backButton')))), _react.default.createElement(_UIBox.default, {
        className: "flex-column m-top-4",
        grow: 1,
        alignSelf: "stretch"
      }, !withPanelNavigator && _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.panels.searchResults', {
        term: searchQuery
      })), isShutterstockEnabled && type === _Constants2.DrawerTypes.IMAGE ? this.renderTabs() : this.renderTiles()));
    }
  }]);
  return SearchPanel;
}(_react.Component);

SearchPanel.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  files: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  tiles: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  stockTiles: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  status: _propTypes.default.oneOf(Object.keys(_Constants.RequestStatus)),
  stockStatus: _propTypes.default.oneOf(Object.keys(_Constants.RequestStatus)),
  total: _propTypes.default.number.isRequired,
  stockTotal: _propTypes.default.number.isRequired,
  searchQuery: _propTypes.default.string.isRequired,
  stockImages: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  fetchFiles: _propTypes.default.func.isRequired,
  searchFolders: _propTypes.default.func.isRequired,
  fetchStockFiles: _propTypes.default.func.isRequired,
  onSearch: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  onBack: _propTypes.default.func.isRequired,
  isShutterstockEnabled: _propTypes.default.bool.isRequired,
  readOnlyReason: _propTypes2.readOnlyReasonProp,
  onTrackInteraction: _propTypes.default.func.isRequired,
  disableUpload: _propTypes.default.bool.isRequired,
  withPanelNavigator: _propTypes.default.bool.isRequired,
  previousSelectedFileId: _propTypes.default.number
};

var mapStateToProps = function mapStateToProps(state, props) {
  var shutterstock = state.shutterstock,
      panel = state.panel;
  var stockTiles = (0, _Tiles.getStockTiles)(state, props);
  var files = (0, _Files.getFiles)(state);
  var tiles = (0, _Tiles.getSearchTiles)(state, props);
  return {
    files: files,
    total: (0, _Tiles2.getTotalFilteredTiles)({
      savedFilesCount: (0, _Files.getFilesTotal)(state),
      files: files,
      tiles: tiles
    }),
    stockTiles: stockTiles,
    tiles: tiles,
    stockTotal: shutterstock.get('total'),
    stockImages: shutterstock.get('results'),
    stockStatus: shutterstock.get('searchStatus'),
    status: (0, _Files.getFetchFilesRequestStatus)(state),
    searchQuery: panel.getIn(['present', 'searchQuery']),
    isShutterstockEnabled: (0, _Configuration.getIsShutterstockEnabled)(state),
    readOnlyReason: (0, _Permissions.getReadOnlyReason)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onBack: function onBack() {
      dispatch(Actions.goBack());
    },
    onSearch: function onSearch(searchQuery) {
      dispatch(Actions.setSearchQuery(searchQuery));
    },
    onTrackInteraction: function onTrackInteraction(name, action, meta) {
      dispatch(Actions.trackInteraction(name, action, meta));
    },
    fetchFiles: function fetchFiles(_ref) {
      var initial = _ref.initial,
          searchQuery = _ref.searchQuery,
          _ref$offset = _ref.offset,
          offset = _ref$offset === void 0 ? 0 : _ref$offset,
          type = _ref.type;
      var query = Object.assign({
        limit: _Constants2.DEFAULT_ROWS_TO_FETCH * _Constants2.IMAGE_COLUMN_COUNT,
        search: searchQuery,
        offset: offset,
        type: type
      }, (0, _network.getProviderParam)(ownProps.type));

      if (initial) {
        dispatch(Actions.fetchInitialFiles(query, ownProps.type));
      } else {
        dispatch(Actions.fetchMoreFiles(query, ownProps.type));
      }
    },
    fetchStockFiles: function fetchStockFiles(query) {
      var searchQuery = query.searchQuery,
          page = query.page,
          pageSize = query.pageSize,
          initial = query.initial;

      if (initial) {
        dispatch({
          type: _ActionTypes.SEARCH_SHUTTERSTOCK_RESET
        });
      }

      dispatch((0, _Shutterstock.searchShutterstock)({
        searchQuery: searchQuery,
        page: page,
        pageSize: pageSize
      }));
    },
    searchFolders: function searchFolders() {
      dispatch(_FolderFetch.searchFolders.apply(void 0, arguments));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPanel);

exports.default = _default;
module.exports = exports.default;